import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import axios from 'axios';
import { API_BASE } from '../../config/api';
import { FaCalendarAlt, FaUser, FaArrowRight } from 'react-icons/fa';
import './css/BlogPostPage.css';

const BlogPostPage = () => {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!slug) return;
    axios
      .get(`${API_BASE}/api/blog/${slug}`)
      .then((res) => setPost(res.data.post))
      .catch((err) => setError(err.response?.status === 404 ? 'not_found' : err.message))
      .finally(() => setLoading(false));
  }, [slug]);

  const formatDate = (dateStr) => {
    if (!dateStr) return '';
    return new Date(dateStr).toLocaleDateString('ar-EG', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
  };

  const imageUrl = (path) => {
    if (!path) return null;
    if (path.startsWith('http')) return path;
    return `${API_BASE}${path}`;
  };

  if (loading) return <div className="blog-post-page" dir="rtl"><div className="container"><p className="blog-post-loading">جاري التحميل...</p></div></div>;
  if (error === 'not_found' || !post) return <div className="blog-post-page" dir="rtl"><div className="container"><p className="blog-post-error">المنشور غير موجود.</p><Link to="/blog">العودة للمدونة</Link></div></div>;
  if (error) return <div className="blog-post-page" dir="rtl"><div className="container"><p className="blog-post-error">حدث خطأ.</p></div></div>;

  return (
    <div className="blog-post-page" dir="rtl">
      <header className="blog-post-header">
        <div className="container">
          <Link to="/blog" className="back-link">
            <FaArrowRight /> العودة للمدونة
          </Link>
          <motion.h1
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            {post.title}
          </motion.h1>
          <div className="blog-post-meta">
            <span><FaUser /> {post.author}</span>
            <span><FaCalendarAlt /> {formatDate(post.created_at)}</span>
          </div>
        </div>
      </header>

      {imageUrl(post.featured_image) && (
        <div className="blog-post-featured">
          <div className="container">
            <img src={imageUrl(post.featured_image)} alt={post.title} />
          </div>
        </div>
      )}

      <article className="blog-post-content">
        <div className="container container-narrow">
          <div
            className="blog-post-body"
            dangerouslySetInnerHTML={{ __html: post.content }}
          />
        </div>
      </article>
    </div>
  );
};

export default BlogPostPage;
